export const fullDayFormat = (timestamp) => {
  const dateObject = new Date(timestamp);
  const options = { day: "2-digit", month: "short", year: "numeric" };
  const formattedDate = dateObject.toLocaleDateString("en-US", options);

  return formattedDate;
};
//Output: Like "01 Jan 2023"
